module.exports = __webpack_public_path__ + "static/media/Panama-Sofa.d1d2890c.jpg";